import React, {FC} from 'react';

import {LinkedConversationStatusesEnum} from '../../../../../../libs/shared/core/src/models/api/conversationCommonTypes';
import {
  LinkConversationsDropdownItemProps,
  LinkConversationsMoreDropdownItem,
} from './linkConversationsDropdownMoreItem';
import {UnlinkConversationDropdownMoreItem} from './unlinkConversationsDropdownMoreItem';

interface LinkOrUnlinkConversationsDropdownMoreItemProps extends LinkConversationsDropdownItemProps {}

export const LinkOrUnlinkConversationsDropdownMoreItem: FC<LinkOrUnlinkConversationsDropdownMoreItemProps> = (
  props,
) => {
  const {onlyConversation} = props;
  if (onlyConversation && onlyConversation.linkStatus === LinkedConversationStatusesEnum.LINKED) {
    return <UnlinkConversationDropdownMoreItem onlyConversation={onlyConversation} />;
  }
  return <LinkConversationsMoreDropdownItem {...props} />;
};
